import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import styles from "./TaskTypesViewPage.module.css";
import TaskTypeForm from "../../../components/TaskTypeForm/TaskTypeForm";
import {
  useDeleteTaskType,
  useTaskTypes,
} from "../../../services/useTaskTypes";
import { useParams } from "react-router";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { TaskType } from "../../../types/TaskType";
import { useTranslation } from "@coworker/locales";

export default function TaskTypesViewPage() {
  const { id: idString } = useParams<{ id: string }>();
  const id = idString ?? "";
  const { data: taskTypes } = useTaskTypes([id]);
  const { mutateAsync: deleteTaskType } = useDeleteTaskType();
  const fixaNavigate = useFixaNavigate();
  const { t } = useTranslation();

  if (!taskTypes || !taskTypes.length) {
    return "Loading...";
  }

  return (
    <>
      <Linkbar
        items={[
          {
            label: "Task types",
            to: "/task-types",
          },
        ]}
        currentLabel={t(taskTypes[0]!.label)}
        currentAsH1
      />

      <div className={styles["task-types-view-page"]}>
        <TaskTypeForm
          readOnly={true}
          taskTypeValues={taskTypes[0]! as TaskType}
        />
      </div>

      <FixaButton
        onClick={() => {
          fixaNavigate(`/task-types/${id}/edit`);
        }}
        text="Edit"
      />
      <FixaButton
        onClick={async () => {
          await deleteTaskType(id);
          fixaNavigate("/task-types");
        }}
        text="Delete"
      />
    </>
  );
}
